// Dependecies
import { useState, useEffect } from 'react';
import { reject } from 'lodash';
// Store
import companies from '../../store/company';
import user from '../../store/user';

function useCompany() {
  const [, companyActions] = companies();
  const [userStore] = user();
  const [company, setCompany] = useState([]);

  const [vehicles, setVehicles] = useState([]);
  const [number, setNumber] = useState(0);
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');

  const [editAddress, setEditAddress] = useState(true);
  const [editPhone, setEditPhone] = useState(true);
  const [reload, setReload] = useState(false);
  const [reloadVehicles, setReloadVehicles] = useState(false);
  const [alertUpdate, setAlertUpdate] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const [messageAlert, setMessageAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userStore.token) {
      companyActions.getCompany(userStore.token).then(
        (res) => {
          setCompany(res.array.company[0]);
          setMessageAlert(true);
          setAddress(res.array.company[0].adress);
          setPhone(res.array.company[0].phone);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );

      companyActions.getVehicles(userStore.token).then(
        (res) => {
          setReloadVehicles(true);
          setVehicles(res.array);
          setNumber(res.num);
          setMessageAlert(true);
          setReload(true);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
    }
  }, [userStore.token]);

  const submit = (data, id) => {
    try {
      const dat = {
        ...data,
        id,
      };
      setLoading(true);
      setEditAddress(!editAddress);
      companyActions.update(dat, userStore.token).then(
        (res) => {
          if (res.status === 200) {
            setAlertUpdate(true);
            setLoading(false);
          }
        },
        (e) => {
          if (e.status === 401) {
            setMessageError(true);
            setLoading(false);
          }
        }
      );
    } catch (error) {
      setMessageError(true);
      setLoading(false);
    }
  };

  const submitPhone = (data, id) => {
    try {
      const dat = {
        ...data,
        id,
      };
      setLoading(true);
      setEditPhone(!editPhone);
      companyActions.update(dat, userStore.token).then(
        (res) => {
          if (res.status === 200) {
            setAlertUpdate(true);
            setLoading(false);
          }
        },
        (e) => {
          if (e.status === 401) {
            setMessageError(true);
            setLoading(false);
          }
        }
      );
    } catch (error) {
      setMessageError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setAlertUpdate(false);
    }, 5000);

    return () => {
      clearTimeout(timer1);
    };
  }, [alertUpdate]);

  useEffect(() => {
    const timer2 = setTimeout(() => {
      setMessageAlert(false);
    }, 10000);

    return () => {
      clearTimeout(timer2);
    };
  }, [messageAlert]);

  useEffect(() => {
    const timer3 = setTimeout(() => {
      setMessageError(false);
    }, 5000);

    return () => {
      clearTimeout(timer3);
    };
  }, [messageError]);

  return {
    reload,
    reloadVehicles,
    company,
    setCompany,
    user: userStore.user,
    alertUpdate,
    messageError,
    messageAlert,
    loading,
    submit,
    submitPhone,
    setReload,
    address,
    setAddress,
    editAddress,
    setEditAddress,
    phone,
    setPhone,
    editPhone,
    setEditPhone,
    vehicles,
    number,
  };
}

export default useCompany;
